/**
 * Super Admin Subscription Add-on Service
 * Add-on definitions (catalog) and company add-ons API calls
 */
import axios from 'axios';
import { getSuperAdminAuthHeader } from './superAdminAuthService';
import API_CONFIG from '../../config';

const API_URL = API_CONFIG.BASE_URL;

// ---------- Add-on Definitions (catalog) ----------

export const listAddonDefinitions = async () => {
  const response = await axios.get(`${API_URL}/superadmin/addon-definitions`, {
    headers: getSuperAdminAuthHeader(),
  });
  return response.data;
};

export const listActiveAddonDefinitions = async () => {
  const response = await axios.get(`${API_URL}/superadmin/addon-definitions/active`, {
    headers: getSuperAdminAuthHeader(),
  });
  return response.data;
};

export const getAddonDefinitionById = async (id) => {
  const response = await axios.get(`${API_URL}/superadmin/addon-definitions/${id}`, {
    headers: getSuperAdminAuthHeader(),
  });
  return response.data;
};

export const createAddonDefinition = async (data) => {
  const response = await axios.post(`${API_URL}/superadmin/addon-definitions`, data, {
    headers: getSuperAdminAuthHeader(),
  });
  return response.data;
};

export const updateAddonDefinition = async (id, data) => {
  const response = await axios.put(`${API_URL}/superadmin/addon-definitions/${id}`, data, {
    headers: getSuperAdminAuthHeader(),
  });
  return response.data;
};

export const deleteAddonDefinition = async (id) => {
  await axios.delete(`${API_URL}/superadmin/addon-definitions/${id}`, {
    headers: getSuperAdminAuthHeader(),
  });
};

// ---------- Company Add-ons ----------

export const listCompanyAddons = async (companyId) => {
  const response = await axios.get(
    `${API_URL}/company-subscriptions/company/${companyId}/addons`,
    { headers: getSuperAdminAuthHeader() }
  );
  return response.data;
};

export const previewAddonPrice = async (companyId, addonDefinitionId, quantityUnits, durationType) => {
  const response = await axios.post(
    `${API_URL}/company-subscriptions/company/${companyId}/addons/preview`,
    { addonDefinitionId, quantityUnits: quantityUnits || 1, durationType: durationType || 'REMAINING' },
    { headers: getSuperAdminAuthHeader() }
  );
  return response.data;
};

export const addCompanyAddon = async (data) => {
  const response = await axios.post(
    `${API_URL}/company-subscriptions/company/addons`,
    data,
    { headers: getSuperAdminAuthHeader() }
  );
  return response.data;
};

const subscriptionAddonService = {
  listAddonDefinitions,
  listActiveAddonDefinitions,
  getAddonDefinitionById,
  createAddonDefinition,
  updateAddonDefinition,
  deleteAddonDefinition,
  listCompanyAddons,
  previewAddonPrice,
  addCompanyAddon,
};

export default subscriptionAddonService;
